import { lazy } from 'react';

// project imports
import AuthGuard from 'utils/route-guard/AuthGuard';
import MainLayout from 'layout/MainLayout';
import Loadable from 'ui-component/Loadable';

// Parent Imports
const SecurityGaurdHome = Loadable(lazy(() => import('views/securityGaurd/Home')));
const Account = Loadable(lazy(() => import('views/common/Account')));
const SchoolVisiter = Loadable(lazy(() => import('views/securityGaurd/SchoolVisiter')));
const StudentVisiter = Loadable(lazy(() => import('views/securityGaurd/StudentVisiter')));
const NewVisiter = Loadable(lazy(() => import('views/securityGaurd/SchoolVisiter/NewVisiter')));
const SearchVisiter = Loadable(lazy(() => import('views/securityGaurd/SchoolVisiter/SearchVisiter')));
const TodaysVisiter = Loadable(lazy(() => import('views/securityGaurd/SchoolVisiter/TodaysVisiter')));

// ==============================|| MAIN ROUTING ||============================== //

const SecurityGaurdRoutes = {
    path: '/',
    element: (
        <AuthGuard>
            <MainLayout />
        </AuthGuard>
    ),
    children: [
        {
            path: '/home',
            element: <SecurityGaurdHome />
        },
        {
            path: '/home/school-visiter',
            element: <SchoolVisiter />
        },
        {
            path: '/home/school-visiter/NewVisiter',
            element: <NewVisiter />
        },
        {
            path: '/home/school-visiter/SearchVisiter',
            element: <SearchVisiter />
        },
        {
            path: '/home/school-visiter/TodaysVisiter',
            element: <TodaysVisiter />
        },
        {
            path: '/home/student-visiter',
            element: <StudentVisiter />
        },
        {
            path: '/account',
            element: <Account />
        }
    ]
};

export default SecurityGaurdRoutes;
